<template>
    <v-layout>
        <v-flex>
            <v-card>
                <v-card-title>
                    <h3 class="headline mb-0 admin-header">Endpoints</h3>
                    <v-btn text icon color="grey lighten-1" @click="refresh(pagination)"><v-icon>fas fa-sync</v-icon></v-btn>
                </v-card-title>
                <v-card-text>
                    <v-layout wrap>
                        <span class="subheading"><b>Filters:</b></span>
                        <v-icon v-if="showFilters" @click="showFilters = !showFilters">fal fa-chevron-up</v-icon>
                        <v-icon v-if="!showFilters" @click="showFilters = !showFilters">fal fa-chevron-down</v-icon>
                    </v-layout>
                        <v-form v-model="valid" v-if="showFilters" @submit.prevent>
                    <v-layout wrap>
                        <v-flex xs11>
                            <v-layout wrap>
                                <v-flex xs2 ml-4>
                                    <v-text-field label="Id" v-model="id" :rules="[rules.numeric]"></v-text-field>
                                </v-flex>
                                <v-flex xs2 ml-4>
                                    <v-autocomplete
                                    v-model="orgId"
                                    :items="organizations"
                                    label="Organization"
                                        item-text="text"
                                        item-value="value">
                                    </v-autocomplete>
                                </v-flex>
                                <v-flex xs2 ml-4>
                                    <v-select label="Deleted" v-model="deleted" :items="deletedItems"></v-select>
                                </v-flex>
                                <v-flex xs2 ml-4>
                                    <v-text-field label="Name" v-model="name"></v-text-field>
                                </v-flex>
                                <v-flex xs2 ml-4>
                                    <v-text-field label="Description" v-model="description"></v-text-field>
                                </v-flex>
                                <v-flex xs2 ml-4>
                                    <v-text-field label="Alias" v-model="alias"></v-text-field>
                                </v-flex>
                                <v-flex xs2 ml-4>
                                    <v-text-field label="Host" v-model="host"></v-text-field>
                                </v-flex>
                                <v-flex xs2 ml-4>
                                    <v-text-field label="Model" v-model="model"></v-text-field>
                                </v-flex>
                                <v-flex xs2 ml-4>
                                    <v-text-field label="Firmware" v-model="firmware"></v-text-field>
                                </v-flex>
                                <v-flex xs2 ml-4>
                                    <v-text-field label="Directory Number" v-model="dn"></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs1>
                            <button onsubmit="false" class="btn btn-primary" @click="applyFilters" :disabled="!valid">Apply</button>
                            <button onsubmit="false" class="btn btn-default" @click="resetFilters">Reset</button>
                        </v-flex>
                    </v-layout>
                        </v-form>
                    <v-layout wrap>
                        <v-flex xs12>
                            <v-data-table
                              :items="endpoints.content"
                              :loading="loading"
                              :headers="headers"
                              :options.sync="pagination"
                              :footer-props="{'items-per-page-options': [5, 10, 15, 20, 50, 100]}"
                              :server-items-length="totalItems" class="elevation-1"
                            >
                              <template v-slot:item.name="{item}">
                                <td>
                                    <router-link to="" @click.native="editItem(item)">{{item.name}}</router-link>
                                </td>
                              </template>
                              <template v-slot:item.updatedDate="{item}">
                                <td>{{formatDateTime(item.updatedDate)}}</td>
                              </template>
                              <template v-slot:item.deleted="{item}">
                                <td>{{item.deleted ? 'yes' : 'no' }}</td>
                              </template>
                              <template v-slot:item.actions="{item}">
                                <td>
                                    <v-btn text icon @click="editItem(item)" style="height: 0px; width: 0px; padding-right:2px;">
                                        <v-icon v-if="isSUPro" color="grey lighten-1" style="font-size: 18px;" >fas fa-pencil</v-icon>
                                        <v-icon v-else color="grey lighten-1" style="font-size: 18px;" >fas fa-info-circle</v-icon>
                                    </v-btn>
                                </td>
                              </template>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
            <v-dialog v-model="showEditEndpointDialog" max-width="600px">
                <v-card>
                    <v-card-title>
                    <span class="headline">Endpoint</span>
                    </v-card-title>

                    <v-card-text>
                        <v-form v-model="validSystem" @submit.prevent>
                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-flex xs12 class="subheading">
                                   Id: {{editedItem.id}} OrgId: {{editedItem.org.id}} ({{editedItem.org.name}})
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                    <v-text-field v-model="editedItem.name" :rules="[rules.required]" label="Name"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                    <v-text-field v-model="editedItem.description" label="Description"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                    <v-text-field v-model="editedItem.hostAddress" :rules="[rules.required]" label="Host Address"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                    <v-text-field v-model="editedItem.externalId" label="External ID"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                    <v-text-field v-model="editedItem.firmware" label="Firmware"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                    <v-text-field v-model="editedItem.dn" label="DN"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                    <v-text-field v-model="editedItem.login" label="Username"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                    <v-text-field v-model="editedItem.password" label="Password" type="password"></v-text-field>
                                </v-flex>
                                <v-flex sm6 md6>
                                </v-flex>
                                <v-flex xs9>
                                    <v-text-field v-model="editedItem.aliases" label="Aliases"></v-text-field>
                                </v-flex>
                                <v-flex xs3>
                                    <v-checkbox v-model="editedItem.deleted" label="Deleted"></v-checkbox>
                                </v-flex>
                                <v-flex xs12>
                                    <v-textarea v-model="editedItem.miscDataJson" label="Misc Data"></v-textarea>
                                </v-flex>
                            </v-layout>
                        </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn text color="blue darken-1" @click.native="close">{{isSUPro ? 'Cancel' : 'Close'}}</v-btn>
                        <v-btn text v-if="isSUPro" color="blue darken-1" :disabled="!validSystem" @click.native="save">Save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-flex>
    </v-layout>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import _ from 'lodash'
import moment from 'moment'
import Utility from './utility'
export default {
    computed: {
        ...mapGetters('user', {
            organizations: 'getOrganizationsTextValue',
            isSUPro: 'isSUPro'
        }),
        ...mapGetters('menus', {
          findRouteTitle: 'findRouteTitle'
        }),
        routeTitle: {
          get() {
            return this.findRouteTitle(this.$route.name) || this.title
          }
        }
    },
    data() {
        return {
            endpoints: {
                "content": [],
                "totalElements": 0
            },
            loading: false,
            search: '',
            pagination : {
                    descending: true,
                    page: 1,
                    rowsPerPage: 10, // -1 for All",
                    itemsPerPage: 10,
                    sortBy: ["updatedDate"]
            },
            totalItems: 0,
            headers: [
                {text: 'Id', align: 'left', sortable: true, value: 'id'},
                {text: 'Org Id', align: 'left', sortable: true, value: 'org.id'},
                {text: 'Org Name', align: 'left', sortable: true, value: 'org.name'},
                {text: 'Name', align: 'left', sortable: true, value: 'name'},
                {text: 'Description', align: 'left', sortable: true, value: 'description'},
                {text: 'Host', align: 'left', sortable: true, value: 'hostAddress'},
                {text: 'Model', align: 'left', sortable: false, value: 'model'},
                {text: 'Firmware', align: 'left', sortable: true, value: 'firmware'},
                {text: 'Aliases', align: 'left', sortable: true, value: 'aliases'},
                {text: 'DN', align: 'left', sortable: false, value: 'dn'},
                {text: 'Updated Date', align: 'left', sortable: true, value: 'updatedDate'},
                {text: 'Deleted', align: 'left', sortable: true, value: 'deleted'},
                {text: 'Actions', align: 'left', sortable: false, value: 'actions'}
            ],
            deleted: null,
            orgId: null,
            name: null,
            description: null,
            alias: null,
            host: null,
            model: null,
            firmware: null,
            dn: null,
            id: null,
            deletedItems:[
                {text: 'All', value: null},
                {text: 'Deleted only', value: true},
                {text: 'Non-deleted only', value: false}
            ],
            rules: {
                required: value => !!value || 'Required.',
                numeric: value => !value || Number.isInteger(+value) || 'Invalid format'
            },
            valid: false,
            showFilters: true,
            validSystem: false,
            showEditEndpointDialog: false,
            originalItem: null,
            editedItem: {
                id: -1,
                name: '',
                description: '',
                hostAddress: '',
                login: '',
                password: '',
                miscData: {},
                miscDataJson: '',
                deleted: false,
                firmware: '',
                dn: '',
                aliases: '',
                aliasInfo: {},
                org: {id: '', name: ''},
                type: {code: '', name: '', description: ''}
            },
            defaultItem: {
                id: -1,
                name: '',
                description: '',
                hostAddress: '',
                login: '',
                password: '',
                miscData: {},
                miscDataJson: '',
                deleted: false,
                firmware: '',
                dn: '',
                aliases: '',
                aliasInfo: {},
                org: {id: '', name: ''},
                type: {code: '', name: '', description: ''}
            },
            originalPassword: null
        }
    },
    watch: {
        pagination: {
            async handler () {
                await this.refresh(this.pagination)
            }, deep: true
        }
    },
    methods: {
        async refresh(pagination) {

            const { page, itemsPerPage, sortBy, sortDesc } = pagination

            let sort = ""
            if (sortBy && sortBy.length) {
                sort = sortBy[0] + "," + (sortDesc && sortDesc.length && sortDesc[0] ? 'desc' : 'asc')
            }

            let model = this.model ? ('\'*model\":\"' + this.model + '*\'') : this.model

            let id = this.id ? +this.id : this.id

            let filter = Utility.buildQueryString(['id', 'name', 'description', 'misc_data', 'firmware', 'hostAddress', 'dn', 'org_id', 'aliases', 'deleted'],
                              [id, this.name, this.description, model, this.firmware, this.host, this.dn, this.orgId, this.alias, this.deleted],
                              ['name', 'description', 'misc_data', 'firmware', 'hostAddress', 'dn', 'aliases'])

            this.loading = true

            this.endpoints = await this.$store.dispatch('crossorg/getEndpoints',
                {filter, size: itemsPerPage || 10, page: page ? page - 1 : 0, sort})

            this.totalItems = this.endpoints.totalElements

            this.loading = false
        },
        formatDateTime(val) {
            return moment(val).isValid() ? moment(val).format('MM/DD/YYYY, h:mm:ss a') : val
        },
        async resetFilters() {
            this.deleted = null
            this.orgId = null
            this.name = null
            this.description = null
            this.alias = null
            this.host = null
            this.model = null
            this.firmware = null
            this.dn = null
            this.id = null

            await this.refresh(this.pagination)

        },
        async applyFilters() {
            await this.refresh(this.pagination)
        },
        async editItem (item) {
            this.originalItem = item
            this.originalPassword = item.password
            this.editedItem = Object.assign({}, item)
            this.editedItem.miscDataJson = item.miscData ? JSON.stringify(item.miscData) : ""
            this.showEditEndpointDialog = true
        },
        close() {
            this.showEditEndpointDialog = false
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.originalItem = null
                this.originalPassword = null
            }, 300)
        },
        async save () {

            let originalItemWMiscData = Object.assign({}, this.originalItem)
            originalItemWMiscData.miscDataJson = this.originalItem.miscData ? JSON.stringify(this.originalItem.miscData) : ""

            let patchObject = Utility.createPatchObject(originalItemWMiscData, this.editedItem)

            if (patchObject.aliases) {
                let tokens = patchObject.aliases.split("/")
                const sip = tokens.length > 0 ? tokens[0] : ''
                const h323 = tokens.length > 1 ? tokens[1] : ''
                const e164 = tokens.length > 2 ? tokens[2] : ''
                patchObject.aliasInfo = {sip, h323, e164}
            } else if (_.has(patchObject, 'aliases')) {
                patchObject.aliasInfo = {sip: '', h323: '', e164: ''}
            }

            if (patchObject.miscDataJson) {
                patchObject.miscData = JSON.parse(patchObject.miscDataJson)
            }

            await this.$store.dispatch("crossorg/updateEndpoint", {endpoint: this.editedItem,
                                                patchObject, pwd: (this.editedItem.password !== this.originalPassword)})
            this.close()

            await this.refresh(this.pagination)
        }
    }
}
</script>
